import { useState } from 'react';
import SwitchWithLabel from '../../../Components/Form/Inputs/SwitchWithLabel';
import ComponentHeader from '../../../Components/Headers/ComponentHeader';
import cacheService from '../../../Services/Cache/CacheService';
import useLanguage from '../../../Services/Language/useLanguageHook';
import styles from './MaintenancePage.module.scss';

const MaintenancePage: React.FC = () => {
    const [translations] = useLanguage();
    const [forceRefreshCache, setForceRefreshCache] = useState<boolean>(localStorage.getItem('forceRefreshCache') === 'true');
    const [frontendCacheDisabled, setFrontendCacheDisabled] = useState<boolean>(localStorage.getItem('frontendCacheDisabled') === 'true');
    const [enableConsoleDebug, setEnableConsoleDebug] = useState<boolean>(localStorage.getItem('enableConsoleDebug') === 'true');

    const handleBackendCacheChange = (checked: boolean) => {
        setForceRefreshCache(checked);
        localStorage.setItem('forceRefreshCache', checked.toString());
    };

    const handleFrontendCacheChange = (checked: boolean) => {
        setFrontendCacheDisabled(checked);
        localStorage.setItem('frontendCacheDisabled', checked.toString());
        if (checked) {
            cacheService.disable();
        } else {
            cacheService.enable();
        }
    };

    const handleEnableConsoleDebugChange = (checked: boolean) => {
        setEnableConsoleDebug(checked);
        localStorage.setItem('enableConsoleDebug', checked.toString());
    };

    return (
        <div className={styles.maintenance_container}>
            <div className={styles.maintenance_section}>
                <ComponentHeader title={translations.maintenance.headers.cache} />
                <SwitchWithLabel
                    label={translations.maintenance.actions.forceRefreshCache}
                    checked={forceRefreshCache}
                    onChange={handleBackendCacheChange}
                    track={{ eventCategory: 'Maintenance', eventAction: 'ForceRefreshCacheChanged', eventValue: forceRefreshCache }}
                />
                <SwitchWithLabel
                    label={translations.maintenance.actions.disableFrontendCache}
                    checked={frontendCacheDisabled}
                    onChange={handleFrontendCacheChange}
                    track={{ eventCategory: 'Maintenance', eventAction: 'DisableFrontendCacheChanged', eventValue: frontendCacheDisabled }}
                />
            </div>
            <div className={styles.maintenance_section}>
                <ComponentHeader title={translations.maintenance.headers.monitoring} />
                <SwitchWithLabel
                    label={translations.maintenance.actions.enableConsoleDebug}
                    checked={enableConsoleDebug}
                    onChange={handleEnableConsoleDebugChange}
                    track={{ eventCategory: 'Maintenance', eventAction: 'EnableConsoleDebugChanged', eventValue: enableConsoleDebug }}
                />
            </div>
        </div>
    );
};

export default MaintenancePage;
